export default function isUndef(value) {
  return (typeof value === 'undefined')
}
